<template>
  <div id="contenedor-editar-tipo-obra">
    <v-form ref="editarTiposObra" v-model="esFormularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Editar tipo de obra
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Descripción"
            v-model="tipoObra.descripcion"
            :rules="[mixReglas.requerido]"
            v-on:keypress.enter="mixActualizarTipoObra"
            required
          >
          </custom-text-field>
          <v-label>Color</v-label>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-avatar
                class="ma-2"
                size="40"
                :color="tipoObra.color"
                readonly
                v-bind="attrs"
                v-on="on"
              >
              </v-avatar>
            </template>
            <v-color-picker
              v-model="tipoObra.color"
              mode="hexa"
              hide-canvas
              hide-inputs
              hide-mode-switch
              hide-sliders
              show-swatches
              swatches-max-height="200"
            >
            </v-color-picker>
          </v-menu>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarTipoObra"
            :disabled="!esFormularioValido  || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cerrar" text> Cancelar </v-btn>
          <v-btn
            @click="mixActualizarTipoObra"
            color="success"
            :disabled="!esFormularioValido"
            :loading="enviandoFormulario"
          >
            <v-icon left> mdi-pencil </v-icon>
            Actualizar
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoTiposObra from './mixCatalogoTiposObra';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosTiposObraEditar',
  mixins: [mixCatalogoTiposObra],
  props: {
    tipoObraEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      esFormularioValido: false,
      enviandoFormulario: false,
      tipoObra: {
        descripcion: this.tipoObraEditar.descripcion,
        color: this.tipoObraEditar.color,
      },
      menu: false,
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.editarTiposObra.reset();
    },
  },
};
</script>

<style>
</style>
